// Business Settings Interface
export interface BusinessSettings {
  faq: string;
  howItWorks: string;
  terms: string;
  privacyPolicy: string;
  contactEmail: string;
  logoUrl: string;
  domain?: string;
}

// Mock functions for business settings management
// In a real application, these would connect to an API

// Get business settings
export const getBusinessSettings = async (): Promise<BusinessSettings> => {
  // Mock implementation - in a real app, this would fetch from an API
  return new Promise((resolve) => {
    // Simulate API delay
    setTimeout(() => {
      // Load from localStorage if available
      const savedSettings = localStorage.getItem('businessSettings');
      if (savedSettings) {
        resolve(JSON.parse(savedSettings));
      } else {
        // Default settings
        const defaultSettings: BusinessSettings = {
          faq: '',
          howItWorks: '',
          terms: '',
          privacyPolicy: '',
          contactEmail: '',
          logoUrl: '',
          domain: '',
        };
        localStorage.setItem('businessSettings', JSON.stringify(defaultSettings));
        resolve(defaultSettings);
      }
    }, 500);
  });
};

// Save individual section settings
export const saveBusinessSetting = async (
  section: keyof BusinessSettings, 
  content: string
): Promise<void> => {
  // Mock implementation
  return new Promise((resolve) => {
    setTimeout(async () => {
      const currentSettings = await getBusinessSettings();
      const updatedSettings = {
        ...currentSettings,
        [section]: content,
      };
      localStorage.setItem('businessSettings', JSON.stringify(updatedSettings));
      resolve();
    }, 500);
  });
};

// Save logo URL
export const saveLogoUrl = async (logoUrl: string): Promise<void> => {
  return saveBusinessSetting('logoUrl', logoUrl);
};

// Mock file upload function
export const uploadLogo = async (file: File): Promise<string> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // In a real app, this would upload to a server/cloud storage
      // Here we create a data URL for demonstration purposes
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }, 1000);
  });
};
